// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1ccQR","subheader":"ReorderModal_subheader__3-yne","listWrap":"ReorderModal_listWrap__2XmTy"};